import React from "react";
import { Text, View } from "native-base";
import { ChevronDown } from "lucide-react-native";
import Animated from "react-native-reanimated";
import { copyArt } from "../../../HomeScreen/Components/utils";
import PressableWrapp from "../../../Universal/Buttons/PressableReact/PressableWrapp";
import { SpecItem } from "./types";
import { UnitFullV2Styles } from "./styles";

interface UnitFullV2TechnicalInfoProps {
  isSmallVersion: boolean;
  scaleAll: number;
  setTechContentHeight: (height: number) => void;
  styles: UnitFullV2Styles;
  technicalSpecs: SpecItem[];
  techBodyAnimatedStyle: any;
  techChevronAnimatedStyle: any;
  techContentHeight: number;
  onGoToCollection: (collectionName: string) => void;
  onToggle: () => void;
}

const UnitFullV2TechnicalInfo: React.FC<UnitFullV2TechnicalInfoProps> = ({
  isSmallVersion,
  scaleAll,
  setTechContentHeight,
  styles,
  technicalSpecs,
  techBodyAnimatedStyle,
  techChevronAnimatedStyle,
  techContentHeight,
  onGoToCollection,
  onToggle,
}) => (
  <View style={styles.techCard}>
    <PressableWrapp style={styles.techHeader} onPress={onToggle}>
      <Text style={styles.techTitle}>Техническая информация</Text>
      <Animated.View style={techChevronAnimatedStyle}>
        <ChevronDown size={20 * scaleAll} color="#101010" />
      </Animated.View>
    </PressableWrapp>

    <Animated.View style={[styles.techBodyAnimatedWrap, techBodyAnimatedStyle]}>
      <View
        onLayout={(event) => {
          const nextHeight = event.nativeEvent.layout.height;
          if (nextHeight > 0 && nextHeight !== techContentHeight) {
            setTechContentHeight(nextHeight);
          }
        }}
        style={styles.techBody}
      >
        {technicalSpecs.map((item, index) => {
          const isLast = index === technicalSpecs.length - 1;

          const renderValue = () => {
            if (item.action === "collection" && item.actionValue) {
              return (
                <PressableWrapp onPress={() => onGoToCollection(item.actionValue as string)}>
                  <Text style={[styles.specValue, styles.specLink]}>{item.value}</Text>
                </PressableWrapp>
              );
            }

            if (item.action === "copy" && item.actionValue) {
              return (
                <PressableWrapp onPress={() => copyArt({ art: item.actionValue as string })}>
                  <Text style={[styles.specValue, styles.specLink]}>{item.value}</Text>
                </PressableWrapp>
              );
            }

            if (item.renderAsNode) {
              return item.value;
            }

            return <Text style={styles.specValue}>{item.value}</Text>;
          };

          return (
            <View
              key={item.key}
              style={[
                styles.specRow,
                index % 2 === 0 ? styles.specRowAlt : null,
                isSmallVersion ? styles.specRowStack : null,
                isLast ? styles.specRowLast : null,
              ]}
            >
              <Text style={styles.specLabel}>{item.label}</Text>
              <View
                style={[
                  styles.specValueWrap,
                  isSmallVersion ? styles.specValueWrapStack : null,
                ]}
              >
                {renderValue()}
              </View>
            </View>
          );
        })}
      </View>
    </Animated.View>
  </View>
);

export default React.memo(UnitFullV2TechnicalInfo);
